export default __webpack_public_path__ + "static/media/fanari_amea.067832b2.svg";